import { PropsWithChildren } from 'react';

import { VariantProps, cva } from 'class-variance-authority';
import { toast } from 'sonner';

import { CopyIcon } from '@/shared/assets';
import { COLORS, IconPosition, cn } from '@/shared/lib';
import { Button } from '@/shared/ui';

const variants = cva('flex w-full items-center justify-center gap-x-1', {
  variants: {
    variant: {
      primary: 'text-brand-500 hover:text-hover-brand-500-hover',
      white: 'text-base-500 [&_path]:fill-icon-base-500',
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
});

interface CopyAreaProps
  extends PropsWithChildren,
    VariantProps<typeof variants> {
  copyText: string | number;
  className?: string;
  iconPosition?: IconPosition;
  successCopyText?: string;
}

export const CopyArea = ({
  children,
  className,
  copyText,
  iconPosition = 'right',
  variant,
  successCopyText,
}: CopyAreaProps) => {
  const onCopy = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    await navigator.clipboard.writeText(String(copyText));
    toast(successCopyText ?? 'Success copied', {
      icon: <CopyIcon color={COLORS['contrast-500']} />,
    });
  };

  return (
    <Button
      className={cn(variants({ variant }), className)}
      onClick={onCopy}
      variant="clean"
    >
      {iconPosition === 'left' && <CopyIcon fill="currentColor" />}
      {children}
      {iconPosition === 'right' && <CopyIcon fill="currentColor" />}
    </Button>
  );
};
